import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@/core/services/loading.service';
import { LayerService } from '@/core/services/open-api/layer.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUser } from '@/core/models/user';
import { UserService } from '@/core/services/open-api/user.service';
import { Layer } from '@/core/models/layer';
import { delay, retry } from 'rxjs';
@Component({
    selector: 'app-wizard-third',
    templateUrl: './wizard-third.component.html',
    // styleUrls: ['./wizard-third.component.scss'],
    standalone: false,
})
export class WizardThirdComponent implements OnInit {
    firstName: string = '';
    lastName: string = '';
    welcome3_creating_demodata_title = '';
    welcome3_creating_demodata_text1 = '';
    welcome3_title = '';
    welcome3_text1 = '';
    welcome3_text2 = '';
    welcome3_button = '';
    welcome3_layer = '';
    demodata_layer1 = '';
    demodata_layer2 = '';
    showLoading = false;

    constructor(
        private readonly loadingService: LoadingService,
        private readonly translate: TranslateService,
        private userService: UserService,
        private router: Router,
        private layerService: LayerService,
    ) {}

    ngOnInit(): void {
        this.loadingService.setLoading(true);

        this.userService.loadCurrentUser().subscribe((me: CurrentUser) => {
            this.updateUI(me);
            this.goToNext(); // wird hier direkt ausgelöst damit das anleden der Layer losgeht. Rausnehmen wenn man auf der dritten Seite noch Content anzeigen will und das Anlegen der Layer erst mit dem Klick auf den WEiter Button auslösen will
        });

        this.translate.get('welcome3_layer').subscribe((welcome3_layer) => {
            this.welcome3_layer = welcome3_layer;
        });
        this.translate.get('demodata_layer1').subscribe((demodata_layer1) => {
            this.demodata_layer1 = demodata_layer1;
        });
        this.translate.get('demodata_layer2').subscribe((demodata_layer2) => {
            this.demodata_layer2 = demodata_layer2;
        });
        this.translate.get('welcome3_title').subscribe((welcome3_title) => {
            this.welcome3_title = welcome3_title;
        });
        this.translate.get('welcome3_text1').subscribe((welcome3_text1) => {
            this.welcome3_text1 = welcome3_text1;
        });
        this.translate.get('welcome3_text2').subscribe((welcome3_text2) => {
            this.welcome3_text2 = welcome3_text2;
        });
        this.translate.get('welcome3_creating_demodata_title').subscribe((welcome3_creating_demodata_title) => {
            this.welcome3_creating_demodata_title = welcome3_creating_demodata_title;
        });
        this.translate.get('welcome3_creating_demodata_text1').subscribe((welcome3_creating_demodata_text1) => {
            this.welcome3_creating_demodata_text1 = welcome3_creating_demodata_text1;
        });
        this.translate.get('welcome3_button').subscribe((welcome3_button) => {
            this.welcome3_button = welcome3_button;
        });
    }

    private updateUI(me: CurrentUser): void {
        this.firstName = me.firstName;
        this.lastName = me.lastName;

        this.loadingService.setLoading(false);
    }

    goToNext(): void {
        this.showLoading = true;
        this.createDemoTemplate();
    }

    /*
    private startTrial(): void {
        const trialDate = new Date();
        trialDate.setDate(trialDate.getDate() + 30); // add 30 days in future
        const dateToISO = trialDate.toISOString();

        this.userService.startTrial(dateToISO).subscribe(() => {
            const crmContent: any = {
                email: this.me?.email,
            };
            this.crmWebhookService.execute(CrmWebhookEvent.startTrial, crmContent);
        });
    }
    */

    createDemoTemplate(): void {
        this.translate
            .get([
                'demodata_layer1',
                'demodata_layer2',
                'demodata_layer3',
                'demodata_tiledescription1',
                'demodata_tiledescription2',
                'demodata_client1',
                'demodata_client2',
                'demodata_client3',
                'demodata_project1',
                'demodata_project2',
                'demodata_project3',
                'demodata_project4',
                'demodata_project5',
                'demodata_project6',
            ])
            .subscribe((translations) => {
                this.showLoading = true;
                this.layerService
                    .loadLayers()
                    .pipe(retry(4), delay(1000))
                    .subscribe(
                        (layer) => {
                            if (layer.length === 0) {
                                // Start Adding Layers
                                const layerToAdd1: Layer = {
                                    index: 1,
                                    name: translations.demodata_layer1,
                                    visible: true,
                                    // masterlayer: false
                                };

                                const layerToAdd2: Layer = {
                                    index: 2,
                                    name: translations.demodata_layer2,
                                    visible: true,
                                    // masterlayer: true
                                };

                                const layerToAdd3: Layer = {
                                    index: 3,
                                    name: translations.demodata_layer3,
                                    visible: false,
                                    // masterlayer: false
                                };

                                this.layerService
                                    .createIndexLayer(layerToAdd1)
                                    .pipe(retry(4), delay(1000))
                                    .subscribe(
                                        () => {
                                            this.layerService
                                                .createIndexLayer(layerToAdd2)
                                                .pipe(retry(4), delay(1000))
                                                .subscribe(
                                                    () => {
                                                        this.layerService
                                                            .createIndexLayer(layerToAdd3)
                                                            .pipe(retry(4), delay(1000))
                                                            .subscribe(
                                                                () => {
                                                                    this.layerService
                                                                        .loadLayers()
                                                                        .pipe(retry(4), delay(1000))
                                                                        .subscribe(
                                                                            () => {
                                                                                this.userService
                                                                                    .loadCurrentUser(true)
                                                                                    .subscribe(() => {
                                                                                        void this.router.navigate(
                                                                                            ['/onboarding'],
                                                                                            {
                                                                                                queryParams: {
                                                                                                    firstStart: true,
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                    });
                                                                            },
                                                                            (err) => {
                                                                                console.debug(err);
                                                                            },
                                                                        );
                                                                },
                                                                (err) => {
                                                                    console.debug(err);
                                                                },
                                                            );
                                                    },
                                                    (err) => {
                                                        console.debug(err);
                                                    },
                                                );
                                        },
                                        (err) => {
                                            console.debug(err);
                                        },
                                    );
                            }
                        },
                        (err) => {
                            console.debug(err);
                        },
                    );
            });
    }
}
